import { useContext } from 'react'
import axios from 'axios'
import styled from 'styled-components'

import { MODALS_ID } from '../../../constants'

import { abrCancelSubscriptionProduct } from '../../../utils/abr'
import { chCancelSubscriptionProduct } from '../../../utils/ch'

import { ModalContext } from '../../../provider/ModalProvider'

import { useAlert } from '../../../hooks'
import { useUserInfo } from '../../../hooks/useUserInfo'

import { getProductDetail, getUserProductDetail, cancelProduct } from '../../../api/product'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

const ERROR_BLACK_LIST = ['UTIL_001004', 'UTIL_001002', 'UTIL_001003', 'API_044400']

export function CancelProductConfirmModal({
  userProductId,
  productId,
  onDismiss,
}: {
  userProductId: number
  productId: number
  onDismiss: () => void
}) {
  const { closeModal } = useContext(ModalContext)

  const openAlert = useAlert()
  const { data: userInfo } = useUserInfo()

  const close = () => closeModal(MODALS_ID.CANCEL_PRODUCT)

  const errorAlert = (message: string) => {
    openAlert({
      content: (
        <Text size={16} weight={500} lineHeight={24} $textAlign="center">
          {message}
        </Text>
      ),
    })
  }

  const cancel = async () => {
    // 청약 취소 시 airbridge, channel.io 추적 @ahn
    try {
      await cancelProduct(productId)
      successCancel()
    } catch (err) {
      onDismiss()
      const defaultErrorMessage = '청약 취소에 실패했습니다. 다시 시도해주세요.'
      if (axios.isAxiosError(err)) {
        const filteredErrorList = ERROR_BLACK_LIST.includes(err.response?.data.CODE)
        const errorMessage = filteredErrorList ? err.response?.data.message : defaultErrorMessage
        errorAlert(errorMessage)
        return
      }
      errorAlert(defaultErrorMessage)
    }
  }

  const successCancel = async () => {
    const response = await getProductDetail(productId)
    const userProductResponse = await getUserProductDetail(userProductId)

    const identification = userInfo?.identification
    const product = response ?? undefined

    abrCancelSubscriptionProduct(product, userProductResponse)
    chCancelSubscriptionProduct(identification, product, userProductResponse)

    onDismiss()
  }

  return (
    <Modal id={MODALS_ID.CANCEL_PRODUCT}>
      <Content>
        <Text size={16} weight={500} $textAlign="center" $wordBreak="keep-all">
          해당 작품을 청약 취소할까요?
        </Text>
      </Content>
      <Modal.Footer>
        <Button type="default" onClick={close}>
          아니요
        </Button>
        <Button type="primary" onClick={cancel}>
          네
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`
